import { render, staticRenderFns } from "./CreateTemplateMethodPopover.vue?vue&type=template&id=82e89b0c"
import script from "./CreateTemplateMethodPopover.vue?vue&type=script&lang=js"
export * from "./CreateTemplateMethodPopover.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplateMethodPopover.vue?vue&type=style&index=0&id=82e89b0c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports